import { Component, Input, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { CruiseBookingService } from '../../../cruise-booking-page/services/cruise-booking.service';
import { ICruiseDetail } from '../../interfaces/icruise-detail';
import { IShipServiceRemote } from '../../interfaces/iship-service-remote';
import { ICruiseDetailSolution } from '../../interfaces/icruise-detail-solution';
import { ICruiseDetailCabin } from '../../interfaces/icruise-detail-cabin';
import * as dayjs from 'dayjs';
import { CruiseSpecialsStampsService } from '../../../../../shared/services/cruise-specials-stamps.service';
import { Occupancy } from '../../../../../shared/interfaces/occupancy';
import { BookingService } from '../../../../../shared/services/booking.service';
import { CruiseTopId } from '../../../../../shared/models/cruise-top-id.enum';
import { SwiperOptions } from 'swiper';
import {CruiseDetailService} from '../../service/cruise-detail.service';
import groupBy from '../../../../../../utils/groupBy';
import {PROMO_CODES} from '../../../../../../../assets/data/promo-codes';
import {BookingObjectService} from '../../../../../../services/booking-object.service';
import {ICruiseDetailCabinByType} from '../../interfaces/icruise-detail-cabin-by-type';


@Component({
  selector: 'detail-price-grid',
  templateUrl: './detail-price-grid.component.html',
  styleUrls: ['./detail-price-grid.component.scss']
})
export class DetailPriceGridComponent implements OnInit, OnDestroy {
  protected readonly PROMO_CODES = PROMO_CODES;

  @Input() shipService$: Observable<IShipServiceRemote>;
  @Input() set cruiseDetails(cruiseDetails: ICruiseDetail) {
    // metodo eseguito ad ogni update del "cruiseDetails" passato al componente
    this.updateCruiseDetails(cruiseDetails);
  }

  public openCabin = false;
  public config: SwiperOptions = {
    breakpoints: {
      320: {
        slidesPerView: 1
      },
      480: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 4,
        allowTouchMove: false,
        simulateTouch: false
      },
      1200: {
        slidesPerView: 5,
        allowTouchMove: false,
        simulateTouch: false
      },
      1600: {
        slidesPerView: 5,
        allowTouchMove: false,
        simulateTouch: false
      }
    },
    centeredSlides: false,
    slidesPerView: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };
  public configCabin: SwiperOptions = {
    centeredSlides: false,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };
  public configFares: SwiperOptions = {
    breakpoints: {
      320: {
        slidesPerView: 1
      },
      480: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 2
      },
      1200: {
        slidesPerView: 3
      },
      1600: {
        slidesPerView: 3
      }
    },
    centeredSlides: false,
    slidesPerView: 1,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  };

  public indexGrid: any;
  public indexCabin: any;
  public indexFares: any;

  public tourOperatorId: number;
  public allSolutions: ICruiseDetailSolution[];
  public cabinsByTypeSelected: ICruiseDetailCabin[];
  public cabinsGroupedByType: {key: string, selectedCabin: ICruiseDetailCabin, bestCabin: ICruiseDetailCabin, cabins: ICruiseDetailCabin[]}[] ;
  public selectedCabin: ICruiseDetailCabin;
  public selectedSolution: ICruiseDetailSolution;

  public selectedCabinForRadioBtn: string;

  public loadingPriceGridStatus: boolean = false;
  public loadingPriceGridMessage: string = 'Caricamento...';

  public availablesMonths: string[];
  public selectedMonth: string;

  public cruiseTopId = CruiseTopId;

  public occupancy: Occupancy;
  public activePromos: string[] = [];
  public selectedCabinFromSelect: string;
  private cruise: ICruiseDetail;

  private occupancySubscription: Subscription;
  private selectedSolutionSubscription: Subscription;
  private doUpdateSolutionFromCruiseCategorySub: Subscription;

  constructor(
    private _route: ActivatedRoute,
    private _cruiseSpecialsStampsService: CruiseSpecialsStampsService,
    private _cruiseBookingService: CruiseBookingService,
    private _bookingService: BookingService,
    private _cruiseDetailService: CruiseDetailService,
    private _bookingObject: BookingObjectService,
  ) {
    // "occupancy" di default
    this.occupancy = this._bookingService.occupancy;
  }

  /**
   * // FIXME: funzionamento logica griglia solution/cabine cruise da rifattorizzare non appena c'è più tempo a disposizione
   */
  ngOnInit(): void {
    this.occupancySubscription = this._bookingService.occupancy$.subscribe(
      (occupancy) => {
        // aggiorno l'array delle età dei passeggeri
        if (occupancy) {
          this.occupancy = occupancy;

        // svuoto la cache delle chiamate "/category" per solution
        this._cruiseBookingService.updatedSolutionFromCruiseCategoryCache = undefined;
      }
    });

    this.doUpdateSolutionFromCruiseCategorySub = this._cruiseBookingService.doUpdateSolutionFromCruiseCategory$
        .subscribe((doUpdateSolutionFromCruiseCategory) => {
          // aggiorno la griglia prezzi e seleziono automaticamente la solution e cabina disponibile
          if (doUpdateSolutionFromCruiseCategory && this.cruise) {
            // recupero la "selectedSolution" della cruise
            const selectedSolution = this.selectedSolution || this.cruise.selectedSolution;
            this.loadingPriceGridStatus = true;
            this.loadingPriceGridMessage = 'Stiamo verificando la disponibilità e aggiornando i prezzi';
            this._cruiseBookingService.isLoadingUpdateSolutionFromCruiseCat$.next(this.loadingPriceGridStatus);
            this._cruiseBookingService.getUpdatedSolutionFromCruiseCategory(this.cruise, selectedSolution, this.occupancy.ages)
                .then(
                    (solutionUpdated: ICruiseDetailSolution) => {
                      if (solutionUpdated) {
                        // se "allSolutions" non è stato definito, recupero tutte le solutions attualmente "in batch" dall'oggetto "cruise"
                        const allCruiseSolutions: ICruiseDetailSolution[] = this.cruise.solutions;

                        // sovrascrivo la solution aggiornata su quella presente già nell'array delle altre solutions disponibili
                        for (const index in allCruiseSolutions) {
                          if (allCruiseSolutions[index].id === solutionUpdated.id && allCruiseSolutions[index].source === solutionUpdated.source) {
                            allCruiseSolutions[index] = JSON.parse(JSON.stringify(solutionUpdated));
                          }
                        }

                        // aggiorno tutte le solutions disponibili della cruise
                        this.cruise.solutions = allCruiseSolutions;

                        // aggiorno tutte le solutions visibili in griglia per il mese selezionato
                        this.allSolutions = allCruiseSolutions
                            .filter((sol) => dayjs(sol.departureDate).format('MMM YYYY') === this.selectedMonth) || [];

                        if (this.selectedSolution && this.selectedCabin) {
                          // se la solution e la cabin sono selezionati, provvedo a riaggiornare nuovamente le selezioni con i nuovi dati
                          // provenienti dalla "category"

                          // recupero la cabina aggiornata dalla "solutionUpdated"
                          const cabinFromSolutionUpdated = solutionUpdated
                              .cabins
                              .find((cabFromSolUp) => {
                                if ([this.cruiseTopId.AZAMARA, this.cruiseTopId.CELEBRITY, this.cruiseTopId.ROYAL].includes(this.tourOperatorId)) {
                                  if (cabFromSolUp.type) {
                                    return this.selectedCabin.code === cabFromSolUp.code && this.selectedCabin.type === cabFromSolUp.type;
                                  }
                                  return this.selectedCabin.code === cabFromSolUp.code;
                                }
                                return this.selectedCabin.code === cabFromSolUp.code && this.selectedCabin.fare === cabFromSolUp.fare;
                              });

                          if (cabinFromSolutionUpdated?.available) {
                            // se la cabin aggiornata è disponibile, procedo a riaggiornare nuovamente le selezioni solution e cabin con i
                            // nuovi dati provenienti dalla "category"
                            this.selectSolution(solutionUpdated, cabinFromSolutionUpdated);
                          } else {
                            // ... altrimenti, se la cabin selezionata non è piu disponibile, seleziono solo la solution resettando la
                            // cabin selezionata
                            this.openCabin = false;
                            this.selectedCabin = null;
                            this._cruiseBookingService.selectedCabin$.next(this.selectedCabin);
                            this.selectSolution(solutionUpdated);
                          }
                        } else if (!this.selectedSolution) {
                          // se ancora la solution non è stata selezionata (primo caricamento) in griglia, provvedo a farlo impostando
                          // quella aggiornata ritornata dalla "category"
                          this.setDefaultSelectedSolutionAndCabin(solutionUpdated);
                        }
                      }
                    },
                    (error) => console.info(error)
                )
                .finally(() => {
                  this.loadingPriceGridStatus = false;
                  this._cruiseBookingService.isLoadingUpdateSolutionFromCruiseCat$.next(this.loadingPriceGridStatus);
                });
          }
        });
  }

  ngOnDestroy() {
    this._cruiseBookingService.doUpdateSolutionFromCruiseCategory$.next(false);
    this.occupancySubscription?.unsubscribe();
    this.selectedSolutionSubscription?.unsubscribe();
    this.doUpdateSolutionFromCruiseCategorySub?.unsubscribe();

    // svuoto la cache delle chiamate "/category" per solution
    this._cruiseBookingService.updatedSolutionFromCruiseCategoryCache = undefined;

    // resetto la solution selezionata e la cabin
    this._cruiseBookingService.selectedSolution$.next(undefined);
    this._cruiseBookingService.selectedCabin$.next(undefined);
  }

  private groupCabinsByFare(cabins: ICruiseDetailCabin[]): { key: string, selectedCabin: ICruiseDetailCabin, bestCabin: ICruiseDetailCabin, cabins: ICruiseDetailCabin[] }[] {
    const grouped = groupBy(cabins, 'fare');
    return Object.keys(grouped).map(key => {
      const sortedCabins = grouped[key].sort((a, b) => a.price - b.price);
      const bestCabin = sortedCabins[0];
      return {
        key,
        selectedCabin: bestCabin,
        bestCabin,
        cabins: sortedCabins
      };
    });
  }

  public onCabinChange(event: ICruiseDetailCabin, fareGroups: {key: string, bestCabin: ICruiseDetailCabin, selectedCabin: ICruiseDetailCabin, cabins: ICruiseDetailCabin[]}): void {
    console.log('Cabin changed:', event, fareGroups);
    fareGroups.selectedCabin = event;
    this.selectedCabin = event;
    this._cruiseBookingService.selectedCabin$.next(this.selectedCabin);
  }
  public selectMonth(month: string): void {
    this.selectedMonth = month;

    // recupero tutte le solutions disponibili filtrandole per mese selezionato in modo da visualizzarle in griglia
    if (this.allSolutions && this.cruise.solutions) {
      this.allSolutions = this.cruise.solutions
          .filter((sol) => dayjs(sol.departureDate).format('MMM YYYY') === this.selectedMonth) || [];
    }
  }

  public onFareChange(event: Event, fareGroup){
    event.stopImmediatePropagation();
    this.selectedCabin = fareGroup.selectedCabin;
  }

  public selectCabin(cabin: ICruiseDetailCabin): void {
    this.selectedCabin = cabin;

    // imposto una stringa per selezionare la radio button corretta che rappresenta la tariffa della camera
    this.selectedCabinForRadioBtn = `${cabin.id}_${cabin.code}_${cabin.fare}`;

    // aggiorno l'oggetto della cabin selezionata
    this._cruiseBookingService.selectedCabin$.next(this.selectedCabin);
  }

  public disableCabin(cabin: ICruiseDetailCabin): boolean {
    return cabin.available;
  }
  public selectSolution(
      solution?: ICruiseDetailSolution,
      cabin?: ICruiseDetailCabin,
      scrollToCabinsList: boolean = false,
      isDoUpdateSolFromCruiseCat: boolean = false
  ): void {
    // salvo la solution selezionata (se esiste), in una variabile a parte per poterla controllare alla fine del metodo
    const oldSelectedSolution = this.selectedSolution ? JSON.parse(JSON.stringify(this.selectedSolution)) : null;
    this.selectedSolution = solution;

    // se ho passato anche la cabin (ad es. click sulla griglia solutions), seleziono anche questa
    if (cabin) {
      const {bookingObject: currentBookingObject} = this._bookingObject;
      this._bookingObject.bookingObject = {
        ...currentBookingObject,
        selectedSolution: solution,
        selectedCabin: cabin
      };
      this.selectCabin(cabin);
      // salvo le cabine con tipo specifico selezionato in precedenza
      this.cabinsByTypeSelected = this.selectedSolution?.cabinsGroupedByType
        .find((cabinsGroup) => cabinsGroup.type === this.selectedCabin.type)?.cabins || [];
      this.cabinsGroupedByType = this.groupCabinsByFare(this.cabinsByTypeSelected);
      this.calculateGridPriceAndDifference();
      // apro automaticamente il box con la lista tariffe/cabine selezionabili
      this.openCabin = true;

      if (scrollToCabinsList) {
        setTimeout( () => document.querySelector('#boxGridCabin')?.scrollIntoView({behavior : 'smooth'}),250);
      }
    }

    // riformatto le date in oggetto Date per evitare possibili errori durante l'aggiornamento dell'oggetto della solution selezionata
    this.selectedSolution.arrivalDate = (this.selectedSolution?.arrivalDate) ?
      dayjs(this.selectedSolution.arrivalDate).toDate() : this.selectedSolution?.arrivalDate;
    this.selectedSolution.departureDate = (this.selectedSolution?.departureDate) ?
      dayjs(this.selectedSolution.departureDate).toDate() : this.selectedSolution?.departureDate;

    // aggiorno l'oggetto della solution selezionata
    this._cruiseBookingService.selectedSolution$.next(this.selectedSolution);

    // se ho passato il parametro "isDoUpdateSolFromCruiseCat" per indicare che devo aggiornare la solution dalla "category" e, la stessa
    // solution attualmente selezionata è diversa da quella passata in questo metodo (in questo caso in griglia, è stata selezionata una
    // solution differente)
    if (isDoUpdateSolFromCruiseCat &&
      (oldSelectedSolution && oldSelectedSolution.id !== this.selectedSolution.id) &&
      [this.cruiseTopId.COSTA, this.cruiseTopId.ROYAL, this.cruiseTopId.AZAMARA, this.cruiseTopId.CELEBRITY].includes(this.tourOperatorId)) {
      this._cruiseBookingService.doUpdateSolutionFromCruiseCategory$.next(true);
    }
  }

  private calculateGridPriceAndDifference(): void {
    this.cabinsGroupedByType = this.cabinsGroupedByType.map(group => {
      const sortedCabins = group.cabins.sort((a, b) => a.price - b.price);
      const bestCabin = sortedCabins[0];

      const updatedCabins = sortedCabins.map(cabin => {
        const priceDifference = cabin.price - bestCabin.price;
        const formattedDifference = this.formatPriceDifference(priceDifference);

        return {
          ...cabin,
          descriptionWithCode: priceDifference === 0
            ? `${cabin.description} ${cabin.code ? '(' + cabin.code + ')' : ''}`
            : `${cabin.description} ${cabin.code ? '(' + cabin.code + ')' : ''} ${formattedDifference}`,
          disabled: !cabin.available
        };
      });

      const selectedCabinPriceDifference = bestCabin.price - bestCabin.price;
      const selectedCabinFormattedDifference = this.formatPriceDifference(selectedCabinPriceDifference);

      const updatedSelectedCabin = {
        ...bestCabin,
        descriptionWithCode: selectedCabinPriceDifference === 0
          ? `${bestCabin.description} ${bestCabin.code ? '(' + bestCabin.code + ')' : ''}`
          : `${bestCabin.description} ${bestCabin.code ? '(' + bestCabin.code + ')' : ''} ${selectedCabinFormattedDifference}`
      };

      bestCabin.descriptionWithCode = `${bestCabin.description} ${bestCabin.code ? '(' + bestCabin.code + ')' : ''}`;

      return {
        ...group,
        cabins: updatedCabins,
        bestCabin,
        selectedCabin: updatedSelectedCabin
      };
    });
  }

  private formatPriceDifference = (priceDifference: number): string => {
    return priceDifference > 0
      ? ` +€${priceDifference.toLocaleString('it', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
      : priceDifference < 0
        ? ` -€${Math.abs(priceDifference).toLocaleString('it', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`
        : `€0`;
  }

  private getPriceDifferenceClass = (priceDifference: number): string => {
    return priceDifference > 0
      ? 'text-danger'
      : priceDifference < 0
        ? 'text-success'
        : 'text-neutral';
  }
  private getAvailableMonths(solutions: ICruiseDetailSolution[]): string[] {
    // ordino e ritorno i soli mesi di partenza formattati
    const allMonths = solutions
        .sort((a, b) => dayjs(a.departureDate).unix() - dayjs(b.departureDate).unix())
        .map(sol => dayjs(sol.departureDate).format('MMM YYYY'));
    return [...new Set(allMonths)];
  }

  private setDefaultSelectedSolutionAndCabin(selectedSolution: ICruiseDetailSolution): void {
    if (!selectedSolution) {
      return;
    }
    let availableCabinsGroupedByType =
      selectedSolution.cabinsGroupedByType?.filter(
        (cabin) => cabin.bestCabin?.available
      ) || [];
    this.updateBestCabin(availableCabinsGroupedByType);
    this.selectSolution(
      selectedSolution,
      availableCabinsGroupedByType?.[0]?.bestCabin
    );
  }
  private updateBestCabin(availableCabinsGroupedByType: ICruiseDetailCabinByType[]): void {
    if (!availableCabinsGroupedByType?.length) return;

    const firstGroup = availableCabinsGroupedByType[0];

    if (this.activePromos.includes('WINTER_ESCAPE')) {
      firstGroup.bestCabin = firstGroup.cabins
        .filter(c => c.fare === 'myAllinc' && c.available)
        .sort((a, b) => a.price - b.price)[0];
    } else if (this.activePromos.includes('COSTA_DAYS')) {
      firstGroup.bestCabin = firstGroup.cabins
        .filter(c => c.available)
        .sort((a, b) => a.price - b.price)[0];
    }
  }

  private updateCruiseDetails(cruiseDetails: ICruiseDetail): void {
    if (cruiseDetails) {
      this.tourOperatorId = cruiseDetails.tourOperator?.id;
      this.availablesMonths = this.getAvailableMonths(cruiseDetails.solutions);

      this.selectedSolutionSubscription = this._cruiseBookingService.selectedSolution$
          .subscribe((selectedSolution) => {
            if (!selectedSolution && (selectedSolution || !this.selectedSolution)) {
              // FIXME: va rifattorizzata sta parte perche l'observable "cruise$" inserito nel listato di ricerca, ogni volta che
              //  viene "aggiornato" o sovrascritto, fa lanciare diverse volte questo metodo
              // effettuo questo controllo per verificare se sono al primo caricamento (controllo anche il "this.selectedSolution"
              // nel caso la selectedSolution proveniente dall'esterno, non viene reimpostata e rimane una solution differente rispetto
              // a quella del prodotto scelto)

              // seleziono di default il mese della solution attualmente selezionata (del primo caricamento)
              const solutionOfCurrentMonth = (cruiseDetails.selectedSolution?.departureDate) ?
                  dayjs(cruiseDetails.selectedSolution.departureDate).format('MMM YYYY') : null;
              this.selectMonth(solutionOfCurrentMonth || this.availablesMonths[0]);

              // se si tratta di una costa o di una cruise gruppo royal, effettuo la serie di chiamate "/category"
              if (
                [
                  this.cruiseTopId.COSTA,
                  this.cruiseTopId.ROYAL,
                  this.cruiseTopId.AZAMARA,
                  this.cruiseTopId.CELEBRITY,
                ].includes(this.tourOperatorId)
              ) {
                this.cruise = JSON.parse(JSON.stringify(cruiseDetails));
                this.activePromos = this._cruiseDetailService.getActivePromos(this.cruise);

                this._cruiseBookingService.doUpdateSolutionFromCruiseCategory$.next(
                  true
                );
              } else {
                // se si tratta di altre crociere ...
                this.cruise = JSON.parse(JSON.stringify(cruiseDetails));

                // ... altrimenti, recupero le solutions dall'oggetto cruise con le disponibilità "in batch"
                // NB: ovviamente sono filtrati per il mese attualmente selezionato in griglia
                this.allSolutions = JSON.parse(JSON.stringify(this.cruise.solutions))
                    .filter((sol) => dayjs(sol.departureDate).format('MMM YYYY') === this.selectedMonth) || [];

                // autoseleziono in griglia la bestcabin disponibile proveniente dalla "selectedSolution" della cruise
                this.setDefaultSelectedSolutionAndCabin(cruiseDetails.selectedSolution);
              }
            }
          });
    }
  }

  public isCabinDisabled(cabin: ICruiseDetailCabin): boolean {
    return !cabin.available ||
      !cabin.availability ||
      (this.activePromos.includes('WINTER_ESCAPE') &&
        ['myCruise', 'conMyCru'].includes(cabin.fare));
  }
}
